import { Pie } from 'vue-chartjs'
import { stringToColor } from './stringToColor'

export default {
    extends: Pie,

    props: {
        questions: {
            type: Array
        }
    },

    methods: {
        getQuestionBanks() {
            const questionBanks = {}

            for (const question of this.questions) {
                const questionBank = question.questionBank.title

                if (! questionBanks[questionBank]) {
                    questionBanks[questionBank] = 0
                }

                questionBanks[questionBank]++
            }

            return questionBanks
        },

        actualRender() {
            const questionBanks = this.getQuestionBanks()

            const backgrounds = []
            const labels = []
            const data = []

            for (const questionBank in questionBanks) {
                labels.push(`${questionBank}: ${questionBanks[questionBank]}`)
                backgrounds.push(this.stringToColor(questionBank))
                data.push(questionBanks[questionBank])
            }

            this.renderChart({
                labels: labels,
                datasets: [
                    {
                        data: data,
                        backgroundColor: backgrounds
                    }
                ],
            }, {
                legend: {
                    position: 'right',
                    labels: {
                        textAlign: 'right',
                        font: {
                            size: 14
                        }
                    }
                }
            })
        },
        render() {
            this.$nextTick(() => this.actualRender())
        },
        stringToColor
    },

    mounted() {
        this.render()
    }
}
